import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import SimpleBar from 'simplebar-react'

import ConfirmationDialog from '../../../../../../common/components/Modal/ConfirmationDialog/ConfirmationDialog.jsx'
import AddInternalPageModal from '../../Modals/AddInternalPageModal/AddInternalPageModal.jsx'
import { default as PageModel } from '../../util/PageModel.js'
import {
    moveItemInArray,
    deleteItemInArray,
    addItemInArray,
} from '../../Blocks/Controls/ListActionBar/listActionMethods.js'

import Page from './components/Page.jsx'
import PanelHeader from '../components/PanelHeader.jsx'

import './InternalPages.scss'

const InternalPages = ({ pages, selectedPage, onUpdate, onSelectPage }) => {
    const { t } = useTranslation()
    const [isOpenModal, setIsOpenModal] = useState(false)
    const [isOpenConfirmationDialog, setIsOpenConfirmationDialog] = useState(false)
    const [deletedPageId, setDeletedPageId] = useState(null)
    const panelScrollRef = useRef()

    const onClickAddButton = () => {
        if (pages.length === 1) {
            setIsOpenModal(true)
            return
        }
        onAddPage()
    }

    const onOpenDeleteConfirmationDialog = id => {
        setDeletedPageId(id)
        setIsOpenConfirmationDialog(true)
    }

    const onClonePage = id => {
        if (pages.length === 1) {
            setIsOpenModal(true)
            return
        }
        const pageIndex = pages.findIndex(el => el.id === id)
        const parentItem = pages[pageIndex]
        onAddPage(pageIndex + 1, parentItem)
    }

    const onAddPage = (insertBeforeIndex, data) => {
        let newPage
        const _pages = addItemInArray(pages, insertBeforeIndex ? insertBeforeIndex : pages.length, {
            callback: newItem => {
                newPage = new PageModel({ ...newItem })
                return newPage
            },
            namePrefix: 'Page',
            data,
        })
        onUpdate({ pages: _pages })
        onSelectPage(newPage)
    }

    const onDeletePage = () => {
        const index = pages.findIndex(p => p.id === deletedPageId)
        const newPages = deleteItemInArray(pages, index)
        const pagesWithoutLink = JSON.parse(JSON.stringify(newPages).replace(new RegExp(`#${deletedPageId}`, 'g'), ''))
        onUpdate({ pages: pagesWithoutLink })
        onSelectPage(pagesWithoutLink[index - 1])
        setIsOpenConfirmationDialog(false)
    }

    const onChangePosition = (currentIndex, newIndex) => {
        const newPages = moveItemInArray(pages, currentIndex, newIndex)
        onUpdate({ pages: newPages })
    }

    const onRenamePage = (id, name) => {
        const newPages = pages.map(page => (page.id !== id ? page : { ...page, name }))
        onUpdate({ pages: newPages })
    }

    return (
        <div className="internal-pages">
            <PanelHeader className="internal-pages__title" blockName={t('Pages')} scrollRef={panelScrollRef} />
            <SimpleBar
                autoHide={false}
                style={{ height: 'calc(100% - 56px)', width: '100%' }}
                scrollableNodeProps={{ ref: panelScrollRef }}
            >
                <div className="internal-pages__page-list">
                    {pages.map((page, index) => (
                        <Page
                            key={page.id}
                            page={page}
                            selectedPage={selectedPage}
                            index={index}
                            arrayLength={pages.length}
                            methods={{
                                onSelectPage,
                                onRenamePage,
                                onRemove: onOpenDeleteConfirmationDialog,
                                onClone: onClonePage,
                                onChangePosition: onChangePosition,
                            }}
                        />
                    ))}
                </div>
                <div className="internal-pages__add-button" onClick={onClickAddButton}>
                    {t('Add page')}
                </div>
            </SimpleBar>
            {isOpenConfirmationDialog ? (
                <ConfirmationDialog
                    onClose={() => setIsOpenConfirmationDialog(false)}
                    onAction={onDeletePage}
                    data={{
                        headText: t('Are you sure you want to delete this page?'),
                        noteText: t('All blocks on this page will also be deleted.'),
                        actionVariant: 'primary-danger',
                        actionText: t('Delete'),
                        cancelText: t('Cancel'),
                    }}
                />
            ) : null}

            <AddInternalPageModal isOpen={isOpenModal} onAddPage={onAddPage} onClose={() => setIsOpenModal(false)} />
        </div>
    )
}

export default InternalPages
